import { useSelector } from 'react-redux';
import type { IVehicle } from '@makemydeal/dr-platform-types';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const getVehicle = (state: SalesCheckinRootState): IVehicle => {
    return state.salesCheckin.vehicle;
};

export const getAppliedVehicle = (state: SalesCheckinRootState): IVehicle => state.vehicle || ({} as IVehicle);

export const useChangeVehicleSelector = (): IVehicle => {
    return useSelector((state: SalesCheckinRootState) => getVehicle(state));
};

const getVehicleState = (state: any): IVehicle => state.salesCheckin?.vehicle || ({} as IVehicle);

export const getVehicleDetails = (state: any) => {
    const vehicle = getVehicleState(state);
    return {
        make: vehicle.make,
        model: vehicle.model,
        year: vehicle.year
    };
};

export const getVehicleImageUrl = (state: any): string => getVehicleState(state).imageUrl || '';

export const getVehicleVin = (state: any): string => getVehicleState(state).vin || '';
